import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/SignupPages/AuthByContratSuccess/messages';
import { translate } from 'helpers/intl';
import { Grid, Box } from '@material-ui/core';
import {
  StyledBox,
  StyledImg,
  StyledLongBody,
  StyledShortBody,
} from 'containers/SignupPages/AuthByContratSuccess/style';
import get from 'lodash/get';
import { AssuranceIcon } from 'images';
import { sanlamBlue } from 'Material-UI/colors';
export interface ContractInfoType {
  intl: IntlShape;
  typeAssurance: string;
  key1: string;
  key2: string;
  key3: string;
}

const ContractInfo = (props: ContractInfoType) => {
  return (
    <React.Fragment>
      <Box mb={10} px={[6, 12, 18]}>
        <StyledBox padding={2} isRadiusTop>
          <Grid container alignItems="center">
            <Grid item xs={6}>
              <StyledShortBody color={sanlamBlue} weight="500" MarginBottom={0}>
                {props.typeAssurance &&
                  translate({ ...get(messages, [props.typeAssurance]) }, props)}
              </StyledShortBody>
            </Grid>
            <Grid item xs={6}>
              <StyledImg
                src={AssuranceIcon[props.typeAssurance]}
                alt="assuranceIcon"
              />
            </Grid>
          </Grid>
        </StyledBox>

        <StyledBox padding={2} isRadiusTop={false} isBgColor>
          <Grid container alignItems="center" spacing={2}>
            {props.key1 && (
              <React.Fragment>
                <Grid item xs={6}>
                  <StyledShortBody weight="400">
                    {props.typeAssurance &&
                      translate(
                        { ...get(messages, [props.typeAssurance + 'Key1']) },
                        props,
                      )}
                  </StyledShortBody>
                </Grid>
                <Grid item xs={6}>
                  <StyledLongBody weight="500">{props.key1}</StyledLongBody>
                </Grid>
              </React.Fragment>
            )}
            {props.key2 && (
              <React.Fragment>
                <Grid item xs={6}>
                  <StyledShortBody weight="400">
                    {props.typeAssurance &&
                      translate(
                        { ...get(messages, [props.typeAssurance + 'Key2']) },
                        props,
                      )}
                  </StyledShortBody>
                </Grid>
                <Grid item xs={6}>
                  <StyledLongBody weight="500">{props.key2}</StyledLongBody>
                </Grid>
              </React.Fragment>
            )}
            {props.key3 && (
              <React.Fragment>
                <Grid item xs={6}>
                  <StyledShortBody weight="400">
                    {props.typeAssurance &&
                      translate(
                        { ...get(messages, [props.typeAssurance + 'Key3']) },
                        props,
                      )}
                  </StyledShortBody>
                </Grid>
                <Grid item xs={6}>
                  <StyledLongBody weight="500">{props.key3}</StyledLongBody>
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </StyledBox>
      </Box>
    </React.Fragment>
  );
};

export default injectIntl(ContractInfo);
